export const getOrderIdSelector = (state) => state.checkout.orderId;

export const getTotalCostSelector = (state) => state.checkout.totalCost;

export const isOrderPlacedSelector = (state) => state.checkout.isOrderPlaced;

export const getPotsTid = (state) => state.checkout.potsTid;



// WEBPACK FOOTER //
// ./src/selectors/checkoutSelectors.js